import apiZervant from '../../utils/apiZervant'
import { ZervantTemplate } from './types/templates/zervantTemplate'
import { ZervantSettings } from './types/zervantSettings'

export type FetchZervantSettingsResponseData = ZervantSettings

export const fetchZervantSettings = async () => {
  return apiZervant.settingsService.get<FetchZervantSettingsResponseData>('', {
    headers: { Accept: 'application/json' },
  })
}

type UpdateZervantSettingsResponseData = ZervantSettings

export const updateZervantSettings = async (settings: Partial<ZervantSettings>) => {
  return apiZervant.settingsService.put<UpdateZervantSettingsResponseData>('', settings)
}

export type FetchCustomDocumentTemplateResponse = ZervantTemplate

export const fetchZervantCustomDocumentTemplate = async () => {
  return apiZervant.templates.get<FetchCustomDocumentTemplateResponse>('/document/custom')
}

export type UpdateZervantCustomDocumentTemplatePayload = ZervantTemplate

export const updateZervantCustomDocumentTemplate = async (payload: UpdateZervantCustomDocumentTemplatePayload) => {
  return apiZervant.templates.put<void>('/document/custom', payload)
}
